import { useState } from "react";
import "./App.css";
import ImageGrid from "./Components/ImageGrid";
import Modal from "./Components/Modal";
import Title from "./Components/Title";
import Uploadform from "./Components/UploadForm";

function App() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="App">
      <Title />
      <Uploadform />
      <ImageGrid setSelectedImg={setSelectedImg} />
      {selectedImg && (
        <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
      )}
    </div>
  );
}

export default App;
